import React, { useState } from "react"
import { AssetMap, Round, TeamRound } from "../../types"
import Cookies from "js-cookie"
import TeamLeaderboard from "./TeamLeaderboard"
import IndividualLeaderboard from "./IndividualLeaderboard"

interface LeaderboardProps {
  currentUserId: number
  round: Round
  teamRound: TeamRound
  teamRounds: TeamRound[]
  assets: AssetMap
}

export default function Leaderboard({ currentUserId, round, teamRound, teamRounds, assets }: LeaderboardProps) {
  const [standingsMode, setStandingsMode] = useState(Cookies.get("standings_mode") || "team")

  function updateStandingsMode(newStandingsMode) {
    if (newStandingsMode !== standingsMode) {
      setStandingsMode(newStandingsMode)
      window.setPermanentCookie("standings_mode", newStandingsMode)
    }
  }

  return (
    <>
      <div className="segmented-button" style={{ margin: "1rem 0" }}>
        <ul>
          <li>
            <a className={standingsMode === "team" ? "active" : ""} onClick={() => updateStandingsMode("team")}>
              <img src={assets.team} alt="Team" style={{ width: 16 }} />
              <span>Team</span>
            </a>
          </li>
          <li>
            <a className={standingsMode === "team" ? "" : "active"} onClick={() => updateStandingsMode("individual")}>
              <img src={assets.player} alt="Individual" style={{ width: 16 }} />
              <span>Individual</span>
            </a>
          </li>
        </ul>
      </div>
      {standingsMode === "team" ? (
        <TeamLeaderboard round={round} teamRound={teamRound} teamRounds={teamRounds} />
      ) : (
        <IndividualLeaderboard
          currentUserId={currentUserId}
          teamRounds={teamRounds}
          roundId={round.id}
          leagueId={round.league.id}
        />
      )}
    </>
  )
}
